import { render, staticRenderFns } from "./rounded-small.vue?vue&type=template&id=e8445308&scoped=true&"
import script from "./rounded-small.vue?vue&type=script&lang=js&"
export * from "./rounded-small.vue?vue&type=script&lang=js&"
import style0 from "./rounded-small.vue?vue&type=style&index=0&id=e8445308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8445308",
  null
  
)

export default component.exports